export const rampFields = [
    {
        name: 'FLT Date',
        value: 'd_flight',
        nonTotal: true,
        json: 'flight_date'
    },
    {
        name: 'FLT Number',
        value: 's_flight_number',
        nonTotal: true,
        json: 'flight_number'
    },
    {
        name: 'Aircraft Type',
        value: 's_aircraft_type',
        nonTotal: true,
        json: 'aircraft_type'
    },
    {
        name: 'FLT Turn',
        value: 'flight_turn',
        num: true,
        json: 'flight_turn'
    },
    {
        name: 'Parking',
        value: 'parking',
        num: true,
        json: 'parking'
    },
    {
        name: 'Drayage',
        value: 'drayage',
        num: true,
        json: 'drayage'
    },
    {
        name: 'Lavatory',
        value: 'i_lavatory',
        num: true,
        json: 'lavatory'
    },
    {
        name: 'Water',
        value: 'i_water',
        num: true,
        json: 'water'
    },
    {
        name: 'Cleaning',
        value: 'i_cabin_cleaning',
        num: true,
        json: 'cabin_cleaning'
    },
    {
        name: 'Waste Removal',
        value: 'i_waste_removal',
        num: true,
        json: 'waste_removal'
    },
    {
        name: 'Flight Watch',
        value: 'f_flight_watch',
        num: true,
        json: 'flight_watch'
    },
    {
        name: 'GPU',
        value: 'f_gpu',
        num: true,
        json: 'gpu'
    },
    {
        name: 'ASU',
        value: 'f_asu',
        num: true,
        json: 'asu'
    },
    {
        name: 'Deicing',
        value: 'f_deicing',
        num: true,
        json: 'deicing'
    },
    {
        name: 'Weight Balance',
        value: 'f_weight_balance',
        num: true,
        json: 'weight_balance'
    },
    {
        name: 'Customs',
        value: 'f_customs',
        num: true,
        json: 'customs'
    },
    {
        name: 'GEN DEC',
        value: 'f_gen_dec',
        num: true,
        json: 'gen_dec'
    }
]